import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from "vue";

interface Props {
  modelValue?: number;
  min?: number;
  max?: number;
  decimal?: number;
  debounce?: number;
  placeholder?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'FormatMoney',
  props: {
    modelValue: { default: 0 },
    min: { default: 0 },
    max: { default: Number.MAX_SAFE_INTEGER },
    decimal: { default: 2 },
    debounce: { default: 300 },
    placeholder: { default: "Nhập số tiền" }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emits = __emit;

let timeout: any = null;

// format VNĐ
const formatCurrency = (value: number | string): string => {
  const num = parseNumber(value);

  return num.toLocaleString("vi-VN", {
    minimumFractionDigits: props.decimal,
    maximumFractionDigits: props.decimal,
  });
};

// parse về number
const parseNumber = (value: any): number => {
  if (value === null || value === undefined) {
    return 0;
  }

  let raw = String(value);

  // chỉ giữ số và dấu .
  raw = raw.replace(/[^\d.]/g, "");

  // chỉ cho phép 1 dấu .
  const parts = raw.split(".");
  if (parts.length > 2) {
    raw = `${parts[0]}.${parts.slice(1).join("")}`;
  }

  let num = Number(raw);

  if (isNaN(num)) {
    num = 0;
  }

  // min max
  if (num < props.min) {
    num = props.min;
  }

  if (num > props.max) {
    num = props.max;
  }

  return num;
};

// hiển thị input
const displayValue = computed({
  get: () => formatCurrency(props.modelValue),
  set: (val: string) => {
    debounceEmit(parseNumber(val));
  },
});

// debounce emit
const debounceEmit = (value: number) => {
  clearTimeout(timeout);

  timeout = setTimeout(() => {
    emits("update:modelValue", value);
  }, props.debounce);
};

// nhập input
const handleInput = (e: Event) => {
  const target = e.target as HTMLInputElement;

  // chỉ cho nhập số và .
  target.value = target.value.replace(/[^\d.]/g, "");

  debounceEmit(parseNumber(target.value));
};

// blur format lại
const handleBlur = () => {
  displayValue.value = formatCurrency(props.modelValue);
};

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!

  return (_openBlock(), _createBlock(_component_a_input, {
    value: displayValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((displayValue).value = $event)),
    placeholder: _ctx.placeholder,
    onInput: handleInput,
    onBlur: handleBlur
  }, null, 8, ["value", "placeholder"]))
}
}

})